import config from '../../config/dev.env.js'
let { BASE_API, ZPJ_API } = config;
// 轮播
export const listApi = BASE_API + '/newNews/getNewsColumnData'

// 列表详情
export const listDetails = BASE_API + '/newNews/getNewsDetailData'

// 列表预览量
export const previewAmount = BASE_API + '/newNews/addReadOrShareNum'

// 语音播报
export const speechInterface = BASE_API + '/news/getNewAudio'

// 栏目
export const columnList = BASE_API + '/news/getNewsColumn'

// 获取栏目新街口
export const columnNewsList = BASE_API + '/newNews/getNewsColumnData'

// 获取子栏目接口
export const getColumnByParentId = BASE_API + '/column/getColumnByParentId'

// 检索
export const retrieveListurl = BASE_API + '/news/getNewsChannelData'


// 增加浏览量
export const browseInterface = BASE_API + '/newNews/addReadOrShareNum'


// 濮阳弹框二维码
export const codeDownload = 'https://hongqi.wengegroup.com/activities/app/getAppInfo'



// 广告
// export const advertisingList = ZPJ_API + '/advert/selectAdvertByParam'

export const advertisingList = ZPJ_API + '/site/advert/selectAdvertBySite'

// 签名
export function generateSign() {
    // 生成 sign 字段的值
    var sign = encrpy(JSON.stringify({ 'url': window.location.href, 'timestamp': new Date().getTime(), 'method': 'post' }))// 根据需求生成 sign 的逻辑
    return sign;
}
function encrpy(str) {

    // 密码，顺序与后端相反
    let kk = [6, 2, 8, 3]
    let str1 = base64encode(str)
    let strings = str1.split('');
    let count = strings.length / 2
    for (var k of kk) {
        for (let i = 0; i < count; i += k) {
            let tmp = strings[i];
            strings[i] = strings[count + i];
            strings[count + i] = tmp;
        }
    }
    let result = "";
    for (var s of strings) {
        result += s
    }
    return result;
}
function base64encode(input) {

    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/\r\n/g, "\n");
    var utf8text = "";
    for (var n = 0; n < input.length; n++) {
        var c = input.charCodeAt(n);
        if (c < 128) {
            utf8text += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
            utf8text += String.fromCharCode((c >> 6) | 192);
            utf8text += String.fromCharCode((c & 63) | 128);
        } else {
            utf8text += String.fromCharCode((c >> 12) | 224);
            utf8text += String.fromCharCode(((c >> 6) & 63) | 128);
            utf8text += String.fromCharCode((c & 63) | 128);
        }
    }
    while (i < utf8text.length) {
        chr1 = utf8text.charCodeAt(i++);
        chr2 = utf8text.charCodeAt(i++);
        chr3 = utf8text.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
}


// WEBPACK FOOTER //
// ./src/api/index.js